import React from 'react';
import { Badge } from '../../../../components/ui/badge';
import { CheckCircle, XCircle, HelpCircle } from 'lucide-react';

interface SiteStatusBadgeProps {
  status: 'UP' | 'DOWN' | 'UNKNOWN';
}

const config: Record<string, { variant: 'success' | 'destructive' | 'secondary'; label: string; Icon: typeof CheckCircle }> = {
  UP: { variant: 'success', label: 'Online', Icon: CheckCircle },
  DOWN: { variant: 'destructive', label: 'Offline', Icon: XCircle },
  UNKNOWN: { variant: 'secondary', label: 'Desconhecido', Icon: HelpCircle },
};

const SiteStatusBadge: React.FC<SiteStatusBadgeProps> = ({ status }) => {
  const { variant, label, Icon } = config[status] ?? config.UNKNOWN;
  return (
    <Badge variant={variant} className="gap-1">
      <Icon className="h-3 w-3" />
      {label}
    </Badge>
  );
};

export default SiteStatusBadge;
